import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CompanyFeService } from '../../services/companyfe.service';

@Injectable({ providedIn: 'root' })
export class CompanyGuard implements CanActivate {
    readonly _companyFeService = inject(CompanyFeService);
    readonly _router = inject(Router);

    canActivate(): boolean {
        if (this._companyFeService.selectedUserCompanyId) {
            return true;
        }
        return false;
    }
}